import Swiper from 'swiper'
import './product-slider.scss'

const initSlider = () => {
  new Swiper('.products-slider', {
    slidesPerView: 'auto',
    spaceBetween: 24,
    loop: true,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 24,
        loop: false,
      },
    },
  })
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    initSlider()
  },
  { once: true }
)
